import { Spotlight, SpotlightActionData } from '@mantine/spotlight';
import { IconSearch } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { canAccess } from '../lib/permissions';
import { ALL_NAV_ITEMS } from '../lib/nav';

/** Ctrl/⌘+K global qidiruv — istalgan bo'limga tez o'tish. */
export function SpotlightSearch() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation();

  const actions: SpotlightActionData[] = useMemo(
    () =>
      ALL_NAV_ITEMS.filter((i) => canAccess(user?.role, i.section)).map((i) => ({
        id: i.to,
        label: t(i.labelKey),
        leftSection: <i.icon size={20} stroke={1.6} />,
        onClick: () => navigate(i.to),
      })),
    [user?.role, navigate, t]
  );

  return (
    <Spotlight
      actions={actions}
      shortcut={['mod + K', 'mod + P']}
      nothingFound={t('common.noResults')}
      highlightQuery
      scrollable
      searchProps={{ leftSection: <IconSearch size={20} stroke={1.6} />, placeholder: t('header.search') }}
    />
  );
}
